import { useState } from "react";
import { INTERNAL_PATHS } from "routes/paths";
import {
  useNavigate,
  useNavigateByRedirectCookie
} from "hooks/useCustomNavigation";
import { useShowSnackbar } from "hooks/useShowSnackbar";
import {
  selectDeviceToVerificate,
  validateVerificationCode as validateVerificationCodeRequest
} from "./requests";
import { FEEDBACK_MESSAGES } from "./constants";
import { differenceInDaysBeetweenTwoDates } from "utils/date";
import { setUserToken } from "services/auth";
import { getCookie } from "services/cookies";
import { useAppContext } from "context/app-context";
import { COOKIES } from "constants/cookies";

export const useDeviceVerification = () => {
  const navigate = useNavigate();
  const navigateWithRedirectCookie = useNavigateByRedirectCookie();
  const { addNotification } = useShowSnackbar();
  const { getSessionInfo } = useAppContext();
  const [hasSentCode, setHasSentCode] = useState(false);
  const [verificationMethod, setVerificationMethod] = useState(null);
  const [codeToRaiseUser, setCodeToRaiseUser] = useState(null);

  const sendVerificationCode = async (method) => {
    try {
      const response = await selectDeviceToVerificate({ method });
      if (response?.code) {
        setCodeToRaiseUser(response.code);
      }
      setHasSentCode(true);
      setVerificationMethod(method);
      navigate(INTERNAL_PATHS.DEVICE_VERIFICATION);
    } catch (error) {
      addNotification({
        message: error.response.data.error,
        variant: "error",
        persist: true
      });
    }
  };

  const validateVerificationCode = async (code) => {
    try {
      const { access_token, token_expiration } =
        await validateVerificationCodeRequest({
          code,
          method: verificationMethod
        });
      const daysToExpireToken = differenceInDaysBeetweenTwoDates({
        currentDate: new Date(),
        finishDate: new Date(token_expiration)
      });
      setUserToken({ token: access_token, days: daysToExpireToken });
      await getSessionInfo();
      addNotification({
        message: getSuccessValidationMessage(),
        variant: "success",
        persist: true
      });
      navigateWithRedirectCookie({ defaultRoute: INTERNAL_PATHS.HOME });
    } catch (error) {
      addNotification({
        message: error.response.data.error,
        variant: "error",
        persist: true
      });
    }
  };

  const getSuccessValidationMessage = () => {
    const redirectCookie = getCookie(COOKIES.RETURN_TO);
    return redirectCookie
      ? FEEDBACK_MESSAGES.CHECKOUT_FLOW_SUCCESS
      : FEEDBACK_MESSAGES.LOGIN_SUCCESS;
  };

  return {
    verificationMethod,
    hasSentCode,
    sendVerificationCode,
    validateVerificationCode,
    codeToRaiseUser
  };
};
